import { createSlice } from '@reduxjs/toolkit';

export default createSlice({
  name: 'sidebar',
  initialState: {
    show: false,
  },
  reducers: {
    toggle: (state, action) => {
      state.show = action.payload;
    },
  },
});

export const sideBarProps = (state) => state;
